import React from 'react';
import InfoCard from '../../common/InfoCard/InfoCard';
import { Empty, Spin } from 'antd';
import useCardPagination from '../../../../../hooks/useCardPagination';
import PersonalAccountCard from '../PersonalAccountCard/PersonalAccountCard';
import styles from './PersonalAccount.module.scss';
import { texts } from '../../../constants/texts';
import { useParams } from 'react-router-dom';
import { getQueryKeys } from '../../../queries/queryKeys';
import useHousingStockState from '../../../hooks/useHousingStockState';
import useCurrentAddress from '../../../hooks/useCurrentAddress';
import ActionWithModalAccounts from '../ActionWithModalAccounts/ActionWithModalAccounts';
import useHousingStockHousesState from '../../../hooks/useHousingStockHousesState';

const pageSize = 2;

const PersonalAccount = ({
  className,
  accounts = [],
  loading = false,
  title,
  darkTheme = true,
  onDeleteAccount,
}) => {
  const params = useParams();
  const addressId = Number(params.pageTabId);
  const pageId = Number(params.pageId);
  const { housingStockQueryKey } = useHousingStockState();
  const address = useCurrentAddress();

  const { shownItems, pagination } = useCardPagination(accounts, pageSize);

  const {
    housingStockHousesState: { data: houses },
  } = useHousingStockHousesState();

  const hasHouse = houses?.find((item) => item.houseId === pageId);

  return (
    <InfoCard
      title={title}
      action={accounts.length > pageSize && pagination}
      className={className}
      dark={darkTheme}
    >
      <Spin spinning={loading}>
        {!accounts.length ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <>
            <ul className={styles.metersList}>
              {shownItems.map((account, index) => (
                <li key={index}>
                  <PersonalAccountCard
                    onDeleteAccount={account.bindId && onDeleteAccount}
                    account={account}
                    registrationTypeHouse={hasHouse?.registrationType}
                  />
                </li>
              ))}
            </ul>
          </>
        )}
        <ActionWithModalAccounts
          actionText={texts.addPersonalAccount}
          actionClassName={styles.cardBtn}
          modalProps={{
            address,
            addressId,
            queryKeys: [
              getQueryKeys.flatAccounts(addressId),
              housingStockQueryKey,
            ],
          }}
        />
      </Spin>
    </InfoCard>
  );
};

export default PersonalAccount;
